export const IMAGE_PLACEHOLDER = 'https://i.ibb.co/F4JZ9Rm/ass.png';
